import React from 'react';
import { inject, observer } from 'mobx-react';

import { FullHeightWrapper, SecondaryContainer } from 'ui/Container';

import { CenteredCircularProgress } from 'components/Progress';

import DataError from 'containers/Error/DataError';

import { env } from 'config';

import { InjectedConfigProps } from './types';

@inject('config')
@observer
export default class Config extends React.Component<{ children?: React.ReactNode }> {
  componentDidMount(): void {
    const { config } = this.injected;

    config.loadConfig();
  }

  get injected(): InjectedConfigProps {
    return this.props as InjectedConfigProps;
  }

  render(): React.ReactNode {
    const { children } = this.props;
    const { config } = this.injected;

    // ENG-10919 M1 prototype-mode bypass. The prototype boots workspace
    // against MSW mocks, and `@observer` in this class component doesn't
    // see the `isLoaded` transition under the prototype's vite/babel
    // pipeline — the store updates, the component never re-renders, the
    // app stays on the spinner forever. The root cause is a pre-existing
    // class-component observer subscription bug that doesn't surface in
    // workspace's own build but bites the prototype's. Production / dev
    // run the real gating; the prototype skips straight to children.
    // Track at ENG-10919 follow-up; revert this branch once @observer is
    // fixed (or this container is migrated to a function component).
    if (env.REACT_APP_IS_PROTOTYPE === 'true') {
      return children;
    }

    if (!config.isLoaded) {
      return (
        <FullHeightWrapper>
          <CenteredCircularProgress />;
        </FullHeightWrapper>
      );
    }
    if (config.isFailure) {
      return (
        <SecondaryContainer>
          <DataError onReload={config.loadConfig} />
        </SecondaryContainer>
      );
    }

    return children;
  }
}
